var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var DEFAULTS = {
    typingDelayMs: 100,
    phrasePauseMs: 1000,
    eraseBeforeNext: true,
    eraseDelayMs: 60,
    loop: true,
    shuffle: false,
};
var TypingPlaceholder = /** @class */ (function () {
    function TypingPlaceholder(options) {
        if (options === void 0) { options = {}; }
        this.isRunning = false;
        this.timerId = null;
        this.index = 0;
        var selector = options.selector, element = options.element, phrases = options.phrases, rest = __rest(options, ["selector", "element", "phrases"]);
        var el = element !== null && element !== void 0 ? element : (selector
            ? document.querySelector(selector)
            : null);
        if (!el)
            throw new Error("[TypingPlaceholder] Target element not found.");
        if (!("placeholder" in el))
            throw new Error("[TypingPlaceholder] Target must support placeholder.");
        this.el = el;
        this.opts = __assign(__assign({}, DEFAULTS), rest);
        this.phrases = this.pickPhrases(phrases);
        if (this.opts.shuffle) {
            this.phrases = this.phrases.sort(function () { return Math.random() - 0.5; });
        }
    }
    TypingPlaceholder.prototype.start = function () {
        return __awaiter(this, void 0, Promise, function () {
            var phrase, lastCycleStep, isLastAndNoLoop;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isRunning)
                            return [2 /*return*/];
                        this.isRunning = true;
                        _a.label = 1;
                    case 1:
                        if (!this.isRunning) return [3 /*break*/, 7];
                        phrase = this.phrases[this.index];
                        if (!phrase)
                            return [3 /*break*/, 7];
                        // 1) печатаем
                        return [4 /*yield*/, this.typePhrase(phrase)];
                    case 2:
                        // 1) печатаем
                        _a.sent();
                        if (!this.isRunning)
                            return [3 /*break*/, 7];
                        // 2) ждём паузу после фразы
                        return [4 /*yield*/, this.sleep(this.opts.phrasePauseMs)];
                    case 3:
                        // 2) ждём паузу после фразы
                        _a.sent();
                        if (!this.isRunning)
                            return [3 /*break*/, 7];
                        lastCycleStep = (this.index + 1) % this.phrases.length === 0;
                        isLastAndNoLoop = lastCycleStep && !this.opts.loop;
                        if (!(this.opts.eraseBeforeNext && !isLastAndNoLoop)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.eraseCurrent()];
                    case 4:
                        _a.sent();
                        if (!this.isRunning)
                            return [3 /*break*/, 7];
                        return [3 /*break*/, 6];
                    case 5:
                        if (!this.opts.eraseBeforeNext && !isLastAndNoLoop) {
                            // если не стираем — просто очищаем перед следующей
                            this.setPlaceholder("");
                        }
                        _a.label = 6;
                    case 6:
                        // 4) переходим к следующей
                        this.index = (this.index + 1) % this.phrases.length;
                        // 5) если цикл не зациклен — завершаем
                        if (isLastAndNoLoop) {
                            this.stop();
                        }
                        return [3 /*break*/, 1];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    TypingPlaceholder.prototype.stop = function () {
        this.isRunning = false;
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
    };
    TypingPlaceholder.prototype.setPhrases = function (next, resetIndex) {
        if (resetIndex === void 0) { resetIndex = true; }
        this.phrases = __spreadArray([], __read(next), false);
        if (resetIndex)
            this.index = 0;
    };
    TypingPlaceholder.prototype.typePhrase = function (phrase) {
        return __awaiter(this, void 0, Promise, function () {
            var current, i;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        current = (_a = this.el.getAttribute("placeholder")) !== null && _a !== void 0 ? _a : "";
                        if (current.length) {
                            this.setPlaceholder("");
                            current = "";
                        }
                        i = 0;
                        _b.label = 1;
                    case 1:
                        if (!(i < phrase.length && this.isRunning)) return [3 /*break*/, 4];
                        current += phrase[i];
                        this.setPlaceholder(current);
                        return [4 /*yield*/, this.sleep(this.opts.typingDelayMs)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TypingPlaceholder.prototype.eraseCurrent = function () {
        return __awaiter(this, void 0, Promise, function () {
            var current;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        current = (_a = this.el.getAttribute("placeholder")) !== null && _a !== void 0 ? _a : "";
                        _b.label = 1;
                    case 1:
                        if (!(current.length && this.isRunning)) return [3 /*break*/, 3];
                        current = current.slice(0, -1);
                        this.setPlaceholder(current);
                        return [4 /*yield*/, this.sleep(this.opts.eraseDelayMs)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 1];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TypingPlaceholder.prototype.sleep = function (ms) {
        var _this = this;
        return new Promise(function (resolve) {
            var start = performance.now();
            var tick = function (now) {
                if (!_this.isRunning) {
                    resolve();
                    return;
                }
                if (now - start >= ms) {
                    resolve();
                }
                else {
                    requestAnimationFrame(tick);
                }
            };
            requestAnimationFrame(tick);
        });
    };
    TypingPlaceholder.prototype.setPlaceholder = function (value) {
        this.el.setAttribute("placeholder", value);
    };
    TypingPlaceholder.prototype.pickPhrases = function (fromOptions) {
        if (fromOptions === null || fromOptions === void 0 ? void 0 : fromOptions.length)
            return __spreadArray([], __read(fromOptions), false);
        var raw = this.el.getAttribute("data-phrases");
        if (raw) {
            try {
                var parsed = JSON.parse(raw);
                if (Array.isArray(parsed) &&
                    parsed.every(function (p) { return typeof p === "string"; })) {
                    return parsed;
                }
            }
            catch (_a) {
                // некорректный JSON → используем дефолт ниже
            }
        }
        return [];
    };
    return TypingPlaceholder;
}());
export { TypingPlaceholder };
